module.exports = __webpack_public_path__ + "static/media/info_black_24dp (1).815793e4.svg";